module.exports = __webpack_public_path__ + "img/wedding-2-min.8b398973.png";